<p-toast></p-toast>
<div *ngIf="document as doc else loading">

  <app-create-new-document [parentDocumentId]="doc.DOCID"
                           [(display)]="displayND" (done)="onNewDocument($event)" [countEmptyDocItems]="countEmpty" *ngIf="displayND">

  </app-create-new-document>

  <app-create-new-document [parentDocumentId]="doc.PRIMDOCID"
                           [selectedDocumentId]="doc.DOCID" [(display)]="displayMD" (done)="onRefillDocument($event)" [countEmptyDocItems]="countEmpty" *ngIf="displayMD">

  </app-create-new-document>

  <app-documents-tree [(display)]="displayDC" [documentId]="document.DOCID" *ngIf="displayDC"></app-documents-tree>
  <app-import-excel-dlg [(display)]="displayImportDlg"
                        [paramsMap]="importParamsMap"
                        header="Импорт из XLSX файла"
                        [document]="document"
                        (importIsDone)="onImportDone($event)"
                        *ngIf="displayImportDlg">
  </app-import-excel-dlg>
  <app-confirm-delete-product-part [(display)]="confirmDeleteDocumentOn"
                                   [typeConfirmation]="true"
                                   [confirmText]="confirmDeleteDocumentText"
                                   (done)="onDeleteDocumentConfirmation($event)"
                                   *ngIf="confirmDeleteDocumentOn">
  </app-confirm-delete-product-part>
  <app-confirm-delete-product-part [(display)]="exportConfirmDlg"
                                   [typeConfirmation]="exportConfirmTyped"
                                   [confirmText]="confirmExportDocumentText"
                                   [header]="exportConfirmHeader"
                                   [messageText]="exportConfirmMessage"
                                   (done)="onExportDocumentConfirmation($event)"
                                   *ngIf="exportConfirmDlg">
    <app-document-preflight-summary [result]="preflightResult"
                                    *ngIf="exportConfirmSource === 'preflight' || exportConfirmSource === 'both'">
    </app-document-preflight-summary>
  </app-confirm-delete-product-part>

  <app-export-document [(display)]="exportDS"
                       [documentSpecific]="documentSpecific"
                       [document]="doc"
                       [countEmpty]="countEmpty"
                       *ngIf="exportDS">
  </app-export-document>

  <app-document-preflight-dlg [(display)]="preflightDlg"
                              [result]="preflightResult"
                              [stale]="preflightStale"
                              [loading]="preflightLoading"
                              [error]="preflightError"
                              [canRecheck]="preflightCanRun"
                              (recheck)="onPreflight()"
                              *ngIf="preflightApplicable">
  </app-document-preflight-dlg>

  <p-toolbar styleClass="">
    <ng-template pTemplate="left">
      <p-button label="New" icon="pi pi-plus" styleClass="p-button-success mr-2 hide-label" (onClick)="displayND=true" [disabled]="!documentIsReadyForActions"
                pTooltip="Новый документ (на основе)" tooltipPosition="top"></p-button>

      <p-button label="Заполнить..." icon="pi pi-pencil" styleClass="p-button-success mr-2 hide-label" (onClick)="displayMD=true"
                [disabled]="!doc.PRIMDOCID || !documentIsReadyForActions" pTooltip="Обновить на основе родительского документа" tooltipPosition="top"></p-button>

      <p-button label="Дерево" icon="pi pi-sitemap" styleClass="p-button-help mr-2 hide-label" (onClick)="displayDC=true" [disabled]="!documentIsReadyForActions"
                pTooltip="Показать дерево документов" tooltipPosition="top"></p-button>

      <p-button label="Import" icon="pi pi-upload" styleClass="p-button-info mr-2 hide-label" (onClick)="displayImportDlg=true" [disabled]="!documentIsReadyForActions"
                pTooltip="Импорт содержимого из XLSX файла" tooltipPosition="top"></p-button>
      <p-button [label]="Delete" icon="pi pi-trash" styleClass="p-button-danger mr-2 hide-label" (onClick)="deleteDocumentClick($event)"
                [disabled]="!documentIsReadyForActions" pTooltip="Удалить документ" tooltipPosition="top"></p-button>
      <p-button label="На печать" icon="pi pi-print" styleClass="p-button-info mr-2 hide-label" (onClick)="onExportDocument($event)"
                [loading]="exportChecking" [disabled]="!documentIsReadyForActions || exportChecking" pTooltip="Сохранить документ для печати" tooltipPosition="top"></p-button>

      <p-button label="Перевірка наявності" icon="pi pi-check-square" styleClass="p-button-secondary mr-2 hide-label" (onClick)="onPreflight()"
                *ngIf="preflightApplicable" [loading]="preflightLoading" [disabled]="!preflightCanRun"
                [badge]="preflightBadge" [badgeClass]="preflightBadgeClass"
                [pTooltip]="preflightTooltip" tooltipPosition="top"></p-button>

      <!--<p-inputSwitch [(ngModel)]="swapLeftToRight" pTooltip="Поменять местами" tooltipPosition="top"></p-inputSwitch>-->
    </ng-template>

    <ng-template pTemplate="right">
      <p-menubar [model]="navigationMenu" styleClass="ml-2 mr-2 " />

      <span *ngIf="!production">

        <p-button icon="pi pi-check" styleClass="ml-2 mr-2" [rounded]="true" pTooltip="documentIsReadyForActions" tooltipPosition="top" severity="info" *ngIf="documentIsReadyForActions ; else notdocumentIsReadyForActions" />
        <ng-template #notdocumentIsReadyForActions>
          <p-button icon="pi pi-times" styleClass="mr-2" [rounded]="true" pTooltip="documentIsReadyForActions" tooltipPosition="top" severity="danger" [outlined]="true" />
        </ng-template>

        <p-button icon="pi pi-check" styleClass="mr-2" [rounded]="true" pTooltip="Edited" tooltipPosition="top" *ngIf="edited ; else notedited" />
        <ng-template #notedited>
          <p-button icon="pi pi-times" styleClass="mr-2" [rounded]="true" pTooltip="Edited" tooltipPosition="top" severity="succes" [outlined]="true" />
        </ng-template>

        <p-button icon="pi pi-check" styleClass="mr-2" [rounded]="true" pTooltip="contentLoading" tooltipPosition="top" *ngIf="contentLoading ; else notcontentLoading" />
        <ng-template #notcontentLoading>
          <p-button icon="pi pi-times" styleClass="mr-2" [rounded]="true" pTooltip="contentLoading" tooltipPosition="top" severity="succes" [outlined]="true" />
        </ng-template>

        <p-button icon="pi pi-check" styleClass="mr-2" [rounded]="true" pTooltip="noChangesThere" tooltipPosition="top" severity="succes" *ngIf="noChangesThere ; else notnoChangesThere" />
        <ng-template #notnoChangesThere>
          <p-button icon="pi pi-times" styleClass="mr-2" [rounded]="true" pTooltip="noChangesThere" tooltipPosition="top" [outlined]="true" />
        </ng-template>

        <p-button icon="pi pi-check" styleClass="mr-2" [rounded]="true" pTooltip="documentContentStatus" tooltipPosition="top" *ngIf="documentContentStatus ; else notdocumentContentStatus" />
        <ng-template #notdocumentContentStatus>
          <p-button icon="pi pi-times" styleClass="mr-2" [rounded]="true" pTooltip="documentContentStatus" tooltipPosition="top" severity="succes" [outlined]="true" />
        </ng-template>
      </span>

      <p-button (onClick)="onConfirm(1)" styleClass="p-button-success" [disabled]="!thereAreChangesToSave" pTooltip="Сохранить изменения в документе" tooltipPosition="top">

        <span *ngIf="documentFlagIsValid else documentIsNotReadyForSave">
          <i class="pi pi-check pr-2" *ngIf="(doc.DOCFLAG==0) else flagIsSet"></i> <ng-template #flagIsSet><i class="pi pi-question pr-2"></i></ng-template>
        </span>
        <ng-template #documentIsNotReadyForSave>
          <i class="pi pi-spinner-dotted pr-2"></i>
        </ng-template>

        <span>Сохранить</span>
      </p-button>

    </ng-template>
  </p-toolbar>

  <p-accordion [multiple]="true" (onOpen)="onTabOpen($event)" *ngIf="true">
    <div #anchorDashrow id="anchorDashrow">
      <p-accordionTab [selected]="showTabRowInfo">
        <ng-template pTemplate="header">
          <h3 style="line-height: 1; margin: 0.5rem; background-color:aqua">{{doc.DOCNAMESTR}}</h3>

          <p-button icon="pi pi-copy" styleClass="p-button-information ml-2" [outlined]="true"
                    [cdkCopyToClipboard]="doc.DOCNAMESTR" (onClick)="copyClipBoard(doc.DOCNAMESTR);$event.stopPropagation();"
                    (keydown)="$event.stopPropagation()"
                    pTooltip="Скопировать название в буфер обмена" tooltipPosition="top">
          </p-button>

          <p-button icon="pi pi-link" styleClass="p-button-help ml-2" [outlined]="true"
                    [cdkCopyToClipboard]="baseURL+'row'" (onClick)="copyClipBoard(baseURL+'row');$event.stopPropagation();"
                    (keydown)="$event.stopPropagation()"
                    pTooltip="Скопировать '{{baseURL+'row'}}' в буфер обмена" tooltipPosition="top">
          </p-button>

        </ng-template>
        <app-edit-document-row-info appStopAccordionHomeEnd [document]="doc"></app-edit-document-row-info>
        <div class="grid formgrid justify-content-end">
          <p-button (onClick)="onConfirm(1)" styleClass="p-button-success mr-2" [disabled]="documentIsNotReadyForSave" pTooltip="Сохранить изменения в документе" tooltipPosition="top">
            <i class="pi pi-check pr-2" *ngIf="doc.DOCFLAG==0"></i>
            <i class="pi pi-question pr-2" *ngIf="doc.DOCFLAG!=0"></i>
            <span>Сохранить</span>
          </p-button>
        </div>
      </p-accordionTab>
    </div>

    <div #anchorDashhead id="anchorDashhead">
      <p-accordionTab [selected]="showTabDetails">
        <ng-template pTemplate="header">
          <h5>Реквизиты, дата и сроки</h5>

          <p-button icon="pi pi-link" styleClass="p-button-help ml-4"
                    [outlined]="true"
                    [cdkCopyToClipboard]="baseURL+'head'" (onClick)="copyClipBoard(baseURL+'head');$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                    pTooltip="Скопировать '{{baseURL+'head'}}' в буфер обмена" tooltipPosition="top">
          </p-button>

        </ng-template>
        <div class="formgrid grid" appStopAccordionHomeEnd>
          <div #DDN class="field col-2 xl:col-2 md:col-3 sm:col-6">
            <label for="DN" class="do-not-wrap-text">Номер документа</label>
            <input id="DN" type="text" pInputText [value]="doc.DOCNUMBEREX" readonly />
          </div>
          <div #DDP class="field col-2 xl:col-2 md:col-3 sm:col-6">
            <label for="DD" class="do-not-wrap-text">Дата документа</label>
            <p-calendar id="DD" showTime="true" dateFormat="dd.mm.yy" [(ngModel)]="DOCDATE" (onSelect)="onDateSelect($event)" showButtonBar="true" firstDayOfWeek="1"></p-calendar>
          </div>
          <div #DDE class="field col-2 xl:col-2 md:col-3 sm:col-6">
            <label for="DV" class="do-not-wrap-text">Действителен до</label>
            <p-calendar id="DV" dateFormat="dd.mm.yy" [(ngModel)]="DOCVALDATE" [minDate]="DOCDATE" (onSelect)="onDateValSelect($event)" showButtonBar="true" firstDayOfWeek="1"></p-calendar>
          </div>
          <div #DDV class="field col-2 xl:col-2 md:col-3 sm:col-6">
            <label for="DE" class="do-not-wrap-text">Дата выполнения</label>
            <p-calendar id="DE" dateFormat="dd.mm.yy" [(ngModel)]="DOCEXPDATE" [minDate]="DOCDATE" (onSelect)="onDateExpSelect($event)" showButtonBar="true" firstDayOfWeek="1"></p-calendar>
          </div>
          <div class="field col-4 xl:col-4 md:col-6 sm:col-12">
            <app-currencyselector #cs1 labelKey="Валюта документа ({{doc.DOCCURRID}}) {{doc.DOCRATEVAL}}"
                                  [selectedID]="doc.DOCCURRID"
                                  [_currencyDate]="DOCDATE"
                                  (SelectedCurrency)="onCurrencySelection($event)"></app-currencyselector>
          </div>
          <div class="field col-6 xl:col-6 md:col-6 sm:col-12">
            <app-security-group-selector #sgs1 labelKey="Группа доступа" [selectedID]="doc.SGMGROUPID" (selectedSecurityGroup)="onSelectedSecurityGroup($event)"></app-security-group-selector>
          </div>
          <div class="field col-6 xl:col-6 md:col-12 sm:col-12">
            <app-documentselector #ds1 labelKey="Первичный документ" [documentId]="doc.PRIMDOCID" (selectedDocument)="parentDocumentSelected($event)"></app-documentselector>
          </div>
        </div>
        <div class="grid formgrid justify-content-end">
          <p-button (onClick)="onConfirm(1)" styleClass="p-button-success mr-2" [disabled]="documentIsNotReadyForSave" pTooltip="Сохранить изменения в документе" tooltipPosition="top">
            <i class="pi pi-check pr-2" *ngIf="doc.DOCFLAG==0"></i>
            <i class="pi pi-question pr-2" *ngIf="doc.DOCFLAG!=0"></i>
            <span>Сохранить</span>
          </p-button>
        </div>
      </p-accordionTab>
    </div>

    <div #anchorDashtype id="anchorDashtype">
      <p-accordionTab [selected]="showTabDocTypeInfo">
        <ng-template pTemplate="header">
          <h5>Преамбула и условия</h5>

          <p-button icon="pi pi-link" styleClass="p-button-help ml-4"
                    [outlined]="true"
                    [cdkCopyToClipboard]="baseURL+'type'" (onClick)="copyClipBoard(baseURL+'type');$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                    pTooltip="Скопировать '{{baseURL+'type'}}' в буфер обмена" tooltipPosition="top">
          </p-button>

        </ng-template>
        <div class="fluid formgrid grid" appStopAccordionHomeEnd>
          <div #DDH class="field col-12">
            <p-editor [(ngModel)]="docHeaderStatement" [style]="{'height':'20vw'}">
            </p-editor>
          </div>
          <div #DDF class="field col-12">
            <p-editor [(ngModel)]="docFooterStatement" [style]="{'height':'20vw'}">
            </p-editor>
          </div>
        </div>
      </p-accordionTab>
    </div>

    <div #anchorDashsel id="anchorDashsel">
      <p-accordionTab [header]="" [selected]="showTabSeller">
        <ng-template pTemplate="header">
          <h5>{{side1Label}}</h5>

          <p-button icon="pi pi-link" styleClass="p-button-help ml-4"
                    [outlined]="true"
                    [cdkCopyToClipboard]="baseURL+'sel'" (onClick)="copyClipBoard(baseURL+'sel');$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                    pTooltip="Скопировать '{{baseURL+'sel'}}' в буфер обмена" tooltipPosition="top">
          </p-button>

        </ng-template>
        <app-edit-document-company appStopAccordionHomeEnd [document]="doc" (changes)="onDocumentCompanyChanges($event)"
                                   [manCliLabel]="company1Label" [manPerLabel]="person1Label" [manDepLabel]="department1Label"
                                   [lcoCliLabel]="lcoLabel" [lcoPerLabel]="lcoPer1Label" [lcoDepLabel]="lcoDep1Label">
        </app-edit-document-company>
        <div class="grid formgrid justify-content-end">
          <p-button (onClick)="onConfirm(1)" styleClass="p-button-success mr-2" [disabled]="!thereAreChangesToSave" pTooltip="Сохранить изменения в документе" tooltipPosition="top">

            <span *ngIf="documentFlagIsValid else documentIsNotReadyForSave">
              <i class="pi pi-check pr-2" *ngIf="(doc.DOCFLAG==0) else flagIsSet"></i> <ng-template #flagIsSet><i class="pi pi-question pr-2"></i></ng-template>
            </span>
            <ng-template #documentIsNotReadyForSave>
              <i class="pi pi-spinner-dotted pr-2"></i>
            </ng-template>

            <span>Сохранить</span>
          </p-button>
        </div>
      </p-accordionTab>
    </div>

    <div #anchorDashbuy id="anchorDashbuy">
      <p-accordionTab [header]="" [selected]="showTabCustomer">
        <ng-template pTemplate="header">
          <h5>{{side2Label}}</h5>

          <p-button icon="pi pi-link" styleClass="p-button-help ml-4"
                    [outlined]="true"
                    [cdkCopyToClipboard]="baseURL+'buy'" (onClick)="copyClipBoard(baseURL+'buy');$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                    pTooltip="Скопировать '{{baseURL+'buy'}}' в буфер обмена" tooltipPosition="top">
          </p-button>

        </ng-template>
        <app-edit-document-client appStopAccordionHomeEnd [document]="doc" (changes)="onDocumentClientChanges($event)"
                                  [cliCliLabel]="company2Label" [cliPerLabel]="person2Label" [cliDepLabel]="department2Label"
                                  [pcoCliLabel]="pcoLabel" [pcoPerLabel]="pcoPer2Label" [pcoDepLabel]="pcoDep2Label">
        </app-edit-document-client>
        <div class="grid formgrid justify-content-end">
          <p-button (onClick)="onConfirm(1)" styleClass="p-button-success mr-2" [disabled]="!thereAreChangesToSave" pTooltip="Сохранить изменения в документе" tooltipPosition="top">

            <span *ngIf="documentFlagIsValid else documentIsNotReadyForSave">
              <i class="pi pi-check pr-2" *ngIf="(doc.DOCFLAG==0) else flagIsSet"></i> <ng-template #flagIsSet><i class="pi pi-question pr-2"></i></ng-template>
            </span>
            <ng-template #documentIsNotReadyForSave>
              <i class="pi pi-spinner-dotted pr-2"></i>
            </ng-template>

            <span>Сохранить</span>
          </p-button>
        </div>
      </p-accordionTab>
    </div>

    <div #anchorDashcond id="anchorDashcond">
      <p-accordionTab [selected]="showTabConditions" *ngIf="docTypeInvoice">
        <ng-template pTemplate="header">
          <h5>Условия поставки и примечания</h5>

          <p-button icon="pi pi-link" styleClass="p-button-help ml-4"
                    [outlined]="true"
                    [cdkCopyToClipboard]="baseURL+'cond'" (onClick)="copyClipBoard(baseURL+'cond');$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                    pTooltip="Скопировать '{{baseURL+'cond'}}' в буфер обмена" tooltipPosition="top">
          </p-button>

        </ng-template>
        <app-edit-document-conditions appStopAccordionHomeEnd [document]="doc"
                                      [docDelvConds]="conditions1Label"
                                      [docDelvTerms]="conditions2Label"
                                      [docNoteText1]="conditions3Label"
                                      [docNoteText2]="conditions4Label">
        </app-edit-document-conditions>
        <div class="grid formgrid justify-content-end">
          <p-button (onClick)="onConfirm(1)" styleClass="p-button-success mr-2" [disabled]="!thereAreChangesToSave" pTooltip="Сохранить изменения в документе" tooltipPosition="top">

            <span *ngIf="documentFlagIsValid else documentIsNotReadyForSave">
              <i class="pi pi-check pr-2" *ngIf="(doc.DOCFLAG==0) else flagIsSet"></i> <ng-template #flagIsSet><i class="pi pi-question pr-2"></i></ng-template>
            </span>
            <ng-template #documentIsNotReadyForSave>
              <i class="pi pi-spinner-dotted pr-2"></i>
            </ng-template>

            <span>Сохранить</span>
          </p-button>
        </div>
      </p-accordionTab>
    </div>

    <div #anchorDashpay id="anchorDashpay">
      <p-accordionTab [selected]="showTabPayments" *ngIf="docTypeInvoice">
        <ng-template pTemplate="header">
          <h5>Платежи по счету</h5>

          <p-button icon="pi pi-link" styleClass="p-button-help ml-4"
                    [outlined]="true"
                    [cdkCopyToClipboard]="baseURL+'pay'" (onClick)="copyClipBoard(baseURL+'pay');$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                    pTooltip="Скопировать '{{baseURL+'pay'}}' в буфер обмена" tooltipPosition="top">
          </p-button>

        </ng-template>
        <app-list-document-payments appStopAccordionHomeEnd [document]="doc"></app-list-document-payments>
      </p-accordionTab>
    </div>

    <div #anchorDasherr id="anchorDasherr">
      <p-accordionTab [selected]="showTabErrors" *ngIf="docTypeInvoice">
        <ng-template pTemplate="header">
          <h5>Замечания к документу</h5>

          <p-button icon="pi pi-link" styleClass="p-button-help ml-4"
                    [outlined]="true"
                    [cdkCopyToClipboard]="baseURL+'err'" (onClick)="copyClipBoard(baseURL+'err');$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                    pTooltip="Скопировать '{{baseURL+'err'}}' в буфер обмена" tooltipPosition="top">
          </p-button>

        </ng-template>
        <app-list-document-warnings appStopAccordionHomeEnd [document]="doc"></app-list-document-warnings>
      </p-accordionTab>
    </div>

    <p-accordionTab [selected]="showTabConditions" *ngIf="docTypePayment">
      <ng-template pTemplate="header">
        <h5>Условия поставки и примечания</h5>

        <p-button icon="pi pi-link" styleClass="p-button-help ml-4"
                  [outlined]="true"
                  [cdkCopyToClipboard]="baseURL+'cond'" (onClick)="copyClipBoard(baseURL+'cond');$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                  pTooltip="Скопировать '{{baseURL+'cond'}}' в буфер обмена" tooltipPosition="top">
        </p-button>

      </ng-template>
      <app-edit-document-conditions-receipt appStopAccordionHomeEnd [document]="doc"
                                            [docDelvConds]="conditions1Label"
                                            [docDelvTerms]="conditions2Label"
                                            [docNoteText1]="conditions3Label"
                                            [docNoteText2]="conditions4Label">
      </app-edit-document-conditions-receipt>
      <div class="grid formgrid justify-content-end">
        <p-button (onClick)="onConfirm(1)" styleClass="p-button-success mr-2" [disabled]="!thereAreChangesToSave" pTooltip="Сохранить изменения в документе" tooltipPosition="top">

          <span *ngIf="documentFlagIsValid else documentIsNotReadyForSave">
            <i class="pi pi-check pr-2" *ngIf="(doc.DOCFLAG==0) else flagIsSet"></i> <ng-template #flagIsSet><i class="pi pi-question pr-2"></i></ng-template>
          </span>
          <ng-template #documentIsNotReadyForSave>
            <i class="pi pi-spinner-dotted pr-2"></i>
          </ng-template>

          <span>Сохранить</span>
        </p-button>
      </div>
    </p-accordionTab>

    <div #anchorDashtable id="anchorDashtable">
      <p-accordionTab [selected]="showTabTable" *ngIf="docTypeInvoice">
        <ng-template pTemplate="header">
          <h5>Товары: содержание документа</h5>

          <p-button icon="pi pi-link" styleClass="p-button-help ml-4"
                    [outlined]="true"
                    [cdkCopyToClipboard]="baseURL+'table'" (onClick)="copyClipBoard(baseURL+'table');$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                    pTooltip="Скопировать '{{baseURL+'table'}}' в буфер обмена" tooltipPosition="top">
          </p-button>

        </ng-template>
        <app-edit-document-content appStopAccordionHomeEnd [knockKnock]="knockKnock"
                                   [inputDocument]="document"
                                   (editing)="onEditing($event)"
                                   (contentLoading)="onLoadingContent($event)"
                                   (getDocumentStatus)="onGetDocumentStatus($event)"
                                   (countEmptyChange)="onCountEmptyChange($event)">

        </app-edit-document-content>
      </p-accordionTab>
    </div>

    <p-accordionTab [selected]="showTabTable" *ngIf="docTypePayment">
      <ng-template pTemplate="header">
        <h5>Оплата {{editing}}</h5>
      </ng-template>
      <app-edit-document-content-payment appStopAccordionHomeEnd [inputDocument]="document" (editing)="onEditing($event)"></app-edit-document-content-payment>
    </p-accordionTab>

    <div #anchorDashman id="anchorDashman">
      <p-accordionTab [selected]="false" *ngIf="thereIsManufacture">
        <ng-template pTemplate="header">
          <h5>Монитор производства</h5>

          <p-button icon="pi pi-link" styleClass="p-button-help ml-4"
                    [outlined]="true"
                    [cdkCopyToClipboard]="baseURL+'man'" (onClick)="copyClipBoard(baseURL+'man');$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                    pTooltip="Скопировать '{{baseURL+'man'}}' в буфер обмена" tooltipPosition="top">
          </p-button>

        </ng-template>
        <div class="grid formgrid" appStopAccordionHomeEnd>
          <app-list-manufacturing-status [docId]="doc.DOCID"></app-list-manufacturing-status>
        </div>
      </p-accordionTab>
    </div>

    <div #anchorDashres id="anchorDashres">
      <p-accordionTab [disabled]="(resultIsReady == false)" [selected]="showTabSaleResult" *ngIf="canSeeFinanceResult">
        <ng-template pTemplate="header">
          <h5>Оценка результатов</h5>
        </ng-template>
        <div class="fluid grid">
          <div class="field col-12">
          </div>
        </div>
      </p-accordionTab>
    </div>

    <div #anchorDashtran id="anchorDashtran">
      <p-accordionTab [disabled]="!movementIsReady" [selected]="showTabTransaction">
        <ng-template pTemplate="header">
          <h5>Движение</h5>

          <p-button icon="pi pi-link" styleClass="p-button-help ml-4"
                    [outlined]="true"
                    [cdkCopyToClipboard]="baseURL+'tran'" (onClick)="copyClipBoard(baseURL+'tran');$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                    pTooltip="Скопировать '{{baseURL+'tran'}}' в буфер обмена" tooltipPosition="top">
          </p-button>

        </ng-template>
        <app-document-transaction-table appStopAccordionHomeEnd [inputDocument]="doc"></app-document-transaction-table>
      </p-accordionTab>
    </div>
  </p-accordion>
  <p-scrollTop />
</div>
<ng-template #loading>
  <p>Документ загружается...</p>
</ng-template>

